
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curated-classes/[playlistTitle]/[playlistUID]",
      function () {
        return require("private-next-pages/curated-classes/[playlistTitle]/[playlistUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curated-classes/[playlistTitle]/[playlistUID]"])
      });
    }
  